<template functional>
    <!-- <div class="d-flex justify-content-center align-items-center">
        <div class="text-center" :class="props.innerClass"> -->
            <span class="spl-spinner-span">
                <svg width="220" height="200" viewBox="0 0 220 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.39231 118C-1.03847 106.862 -1.03847 93.1384 5.39231 82L42.1077 18.4071C48.5385 7.26865 60.423 0.407087 73.2846 0.407087H146.715C159.577 0.407087 171.462 7.26865 177.892 18.4071L214.608 82C221.038 93.1384 221.038 106.862 214.608 118L177.892 181.593C171.462 192.731 159.577 199.593 146.715 199.593H73.2846C60.423 199.593 48.5385 192.731 42.1077 181.593L5.39231 118Z" fill="gray"/>
                    
                </svg>
            </span>
        <!-- </div>

        url(#paint0_linear)
        <defs>
        <linearGradient id="paint0_linear" x1="-5" y1="100" x2="225" y2="100" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#0F60FF"/>
                    <stop offset="0.265625" stop-color="#1C64F2"/>
                    <stop offset="0.572917" stop-color="#0F83E4"/>
                    <stop offset="0.942708" stop-color="#2AB2DA"/>
                    </linearGradient>
        </defs>


    </div> -->
</template>

<script>

export default {
    functional: true,
    name: 'SplSpinner',
    components: {},
    props: {
        small: {  // sets spinner to small size
            type: Boolean,
            default: false,
        },
        variant: {  // BS color variant
            type: String,
            default: 'primary'
        },
        text: {
            type: String,
            default: ''
        },
        innerClass: {  // useful for padding/margin since outide div is w-100 h-100
            type: String,
            required: false,
        }
    },
}
</script>

<style lang="scss">


.spl-spinner-span {
    svg {
        //background-color: rebeccapurple;
        //border-radius: 10px;
        width: 50px;  // yes! this works for sizing the SVG, keeps the aspect ratio
        height: 50px;
        animation-name: splspinnerrotate;
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
    }

    // svg:hover {
    //     animation-name: splspinnerrotate;
    //     animation-duration: 1.5s;
    //     animation-iteration-count: infinite;
    // }

    @keyframes splspinnerrotate {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}

</style>